import Datagent from "datagent";
import axios from 'axios';
import conf from '../configs/index';
import { ACCOUNT_HOST } from '@/configs/host.conf';


const instance = {
    base: axios.create(),
    production: axios.create({
        baseURL: conf.host,
        // xsrfCookieName: 'laravel_session'
    }),
    develop: axios.create({
        baseURL: conf.host,
        // baseURL: location.origin+':8881/api/mobile',
        // xsrfCookieName: 'laravel_session'
    }),
    account: axios.create({
        baseURL: ACCOUNT_HOST,
        // xsrfCookieName: 'laravel_session'
    })
};
// instance.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
export default Datagent.Contact(instance, 'develop');
